module.exports=jQuery;